import React from 'react';
import { Navigate } from 'react-router-dom';
import SecureLS from 'secure-ls'

const ls = new SecureLS({encodingType: 'aes'})

const ProtectedRoute = ({ children }) => {
    const token = ls.get('jwt');
    return token ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
